import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobelgaumtaxifare() {



    const cardData = {




keyword: "Pune to Belgaum Taxi Fare",

headingDescription: "Belgaum Taxi Service provides affordable and transparent Pune to Belgaum taxi fare options for passengers looking for comfortable and reliable outstation travel. Our taxi fares are designed according to vehicle type, travel requirements, and journey preferences, including Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options. Whether you are traveling for business meetings, family visits, airport transfers, medical purposes, educational trips, or personal travel, we provide safe and convenient taxi services with experienced drivers. With doorstep pickup, clean vehicles, flexible booking options, clear pricing, and 24/7 customer support, Belgaum Taxi Service ensures a smooth and comfortable journey from Pune to Belgaum.",

topPlaces: [
  {
    title: "Belagavi Airport",
    description: "Belagavi Airport is a major travel destination for passengers arriving in Belgaum. Taxi services provide convenient airport transfers for business travelers, families, and tourists."
  },
  {
    title: "Belagavi Fort",
    description: "Belagavi Fort is one of the city's most famous historical landmarks, known for its heritage structures, temples, and cultural importance."
  },
  {
    title: "Kamal Basti",
    description: "Kamal Basti is an ancient Jain temple in Belgaum known for its beautiful architecture and historical significance, attracting visitors throughout the year."
  },
  {
    title: "Gokak Falls",
    description: "Gokak Falls is a popular natural attraction near Belgaum, famous for its waterfall, scenic views, and peaceful surroundings, making it ideal for family trips."
  },
  {
    title: "Kittur",
    description: "Kittur is a historic destination near Belgaum known for Kittur Fort and the legacy of Rani Chennamma, attracting history enthusiasts and tourists."
  },
  {
    title: "Savadatti",
    description: "Savadatti is a famous pilgrimage destination near Belgaum, known for Yellamma Temple and religious importance among devotees."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a popular adventure destination near Belgaum, offering wildlife experiences, river rafting, jungle safaris, and nature activities."
  },
  {
    title: "Goa",
    description: "Goa is a preferred holiday destination from Belgaum, known for beaches, resorts, churches, and sightseeing attractions. It is a popular route for private taxi travel."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a nearby Maharashtra city known for Mahalaxmi Temple, shopping, culture, and business activities, making it a frequently traveled destination from Belgaum."
  },
  {
    title: "Hubballi",
    description: "Hubballi is an important commercial city in Karnataka with business, education, and healthcare facilities, offering convenient connectivity from Belgaum."
  }
],




"services": [
  {
    "name": "Belgaum to Pune One Way Cab",
    "description": "Book Belgaum to Pune One Way Cab for comfortable and affordable single-trip travel without return charges. Enjoy doorstep pickup, professional chauffeurs, clean AC vehicles, transparent pricing, and flexible cab options for business trips, family travel, airport transfers, and personal journeys."
  },
  {
    "name": "Belgaum to Pune Private Taxi",
    "description": "Choose Belgaum to Pune Private Taxi for exclusive chauffeur-driven travel with privacy, comfort, and reliable service. Travel conveniently with well-maintained Sedan, Ertiga, Innova Crysta, and SUV vehicles for a smooth outstation journey."
  },
  {
    "name": "Belgaum to Pune Cab",
    "description": "Book Belgaum to Pune Cab for safe and reliable intercity transportation with experienced drivers and comfortable AC cars. Get convenient travel solutions for family trips, corporate journeys, airport transfers, and long-distance travel."
  },
  {
    "name": "Belgaum to Pune Taxi",
    "description": "Hire Belgaum to Pune Taxi for affordable and comfortable travel between Belgaum and Pune. Enjoy professional chauffeurs, clean vehicles, flexible booking options, and reliable service for personal and business requirements."
  },
  {
    "name": "Belgaum to Pune Cab Service",
    "description": "Choose Belgaum to Pune Cab Service for dependable outstation transportation with premium vehicles and skilled drivers. Our cab services provide safe, comfortable, and timely travel with multiple car options."
  },
  {
    "name": "Belgaum to Pune Taxi Service",
    "description": "Book Belgaum to Pune Taxi Service for hassle-free travel with experienced chauffeurs, affordable fares, and well-maintained vehicles. Suitable for airport transfers, family trips, office travel, and personal journeys."
  },
  {
    "name": "Belgaum to Pune Cab Booking",
    "description": "Complete Belgaum to Pune Cab Booking with easy online reservations, quick confirmation, and flexible vehicle selection. Choose Sedan, Ertiga, Innova Crysta, or SUV cabs according to your travel needs."
  },
  {
    "name": "Belgaum to Pune Car Rental",
    "description": "Choose Belgaum to Pune Car Rental for private chauffeur-driven vehicles with comfortable seating and reliable service. Get premium cars for outstation travel, corporate trips, family tours, and airport transfers."
  },
  {
    "name": "Belgaum to Pune Outstation Cab",
    "description": "Book Belgaum to Pune Outstation Cab for safe long-distance travel with professional drivers and comfortable AC vehicles. Perfect for one way trips, round trips, business travel, and family journeys."
  },
  {
    "name": "Belgaum to Pune Airport Cab",
    "description": "Reserve Belgaum to Pune Airport Cab for punctual airport pickup and drop services. Travel comfortably with experienced chauffeurs, spacious vehicles, and reliable airport transfer solutions."
  },
  {
    "name": "Belgaum to Pune Airport Taxi",
    "description": "Choose Belgaum to Pune Airport Taxi for smooth airport transportation with affordable fares and timely service. Enjoy convenient booking options for passengers, families, and corporate travelers."
  },
  {
    "name": "Belgaum to Pune Innova Crysta Cab",
    "description": "Book Belgaum to Pune Innova Crysta Cab for premium travel comfort with luxury interiors, spacious seating, and experienced drivers. Ideal for family trips, corporate travel, airport transfers, and group journeys."
  },
  {
    "name": "Belgaum to Pune Ertiga Cab",
    "description": "Hire Belgaum to Pune Ertiga Cab for spacious 6 to 7 seater travel with affordable pricing. Perfect for family outings, group travel, and comfortable outstation transportation."
  },
  {
    "name": "Belgaum to Pune Sedan Cab",
    "description": "Choose Belgaum to Pune Sedan Cab for economical and comfortable travel with AC sedan cars and professional chauffeurs. Suitable for business trips, personal journeys, and airport transfers."
  },
  {
    "name": "Belgaum to Pune Round Trip Cab",
    "description": "Book Belgaum to Pune Round Trip Cab for flexible return travel with affordable packages and experienced drivers. Ideal for sightseeing, family visits, corporate meetings, and planned journeys."
  },
  {
    "name": "Cheap Belgaum to Pune Cab",
    "description": "Get Cheap Belgaum to Pune Cab services with affordable fares, reliable vehicles, and professional drivers. Enjoy budget-friendly travel without compromising safety, comfort, and service quality."
  },
  {
    "name": "Best Belgaum to Pune Cab Service",
    "description": "Choose the Best Belgaum to Pune Cab Service offering premium vehicles, experienced chauffeurs, competitive pricing, and dependable transportation solutions for every travel requirement."
  },
  {
    "name": "Online Belgaum to Pune Cab Booking",
    "description": "Complete Online Belgaum to Pune Cab Booking with simple reservations, instant confirmation, transparent pricing, and multiple vehicle options for comfortable and convenient travel."
  },
  {
    "name": "Belgaum to Pune Taxi Fare",
    "description": "Check Belgaum to Pune Taxi Fare with affordable travel packages and flexible cab options. Select Sedan, Ertiga, Innova Crysta, or SUV vehicles based on your journey requirements."
  },
  {
    "name": "Belgaum to Pune Car Hire",
    "description": "Hire Belgaum to Pune Car Hire services for private and comfortable transportation with professional drivers. Choose reliable vehicles for airport travel, business trips, and family journeys."
  },
  {
    "name": "Belgaum to Pune Cab Price",
    "description": "Get affordable Belgaum to Pune Cab Price with transparent fares and multiple vehicle choices. Book comfortable AC cabs for safe and convenient outstation travel."
  },
  {
    "name": "Belgaum to Pune Taxi Booking",
    "description": "Book Belgaum to Pune Taxi Booking services online with quick confirmation and easy reservation facilities. Enjoy smooth travel with trusted drivers and well-maintained vehicles."
  },
  {
    "name": "Belgaum to Pune Travel by Cab",
    "description": "Travel from Belgaum to Pune by Cab with comfortable seating, experienced chauffeurs, and reliable transportation. Enjoy a safe and relaxing journey with flexible travel options."
  },
  {
    "name": "Belgaum to Pune Airport Transfer",
    "description": "Book Belgaum to Pune Airport Transfer services for timely and convenient airport travel. Get professional drivers, clean vehicles, and hassle-free pickup and drop facilities."
  },
  {
    "name": "Belgaum to Pune Family Cab",
    "description": "Choose Belgaum to Pune Family Cab for spacious and comfortable travel with safe driving and reliable service. Ideal for vacations, family visits, and long-distance journeys."
  },
  {
    "name": "Belgaum to Pune Corporate Cab",
    "description": "Book Belgaum to Pune Corporate Cab for business travel solutions with executive vehicles and professional chauffeurs. Perfect for meetings, office travel, and corporate transportation needs."
  },
  {
    "name": "Cab Service in Pune",
    "description": "Book Cab Service in Pune for reliable local and outstation transportation with professional drivers and comfortable vehicles. Get Sedan, SUV, Ertiga, and Innova Crysta cab options."
  },
  {
    "name": "Taxi Service in Pune",
    "description": "Choose Taxi Service in Pune for affordable and convenient travel solutions. Enjoy safe rides, experienced chauffeurs, clean vehicles, and flexible booking options for every journey."
  },
  {
    "name": "Cab Booking in Pune",
    "description": "Complete Cab Booking in Pune with easy online reservations and quick confirmation. Select from multiple vehicle categories for airport rides, local travel, and outstation trips."
  },
  {
    "name": "Outstation Cabs Pune",
    "description": "Book Outstation Cabs Pune for comfortable long-distance journeys with professional drivers and premium vehicles. Enjoy reliable one way and round trip travel services."
  },
  {
    "name": "Cheapest Cab Service in Pune",
    "description": "Find Cheapest Cab Service in Pune offering affordable fares, quality vehicles, and reliable transportation. Enjoy economical travel solutions for local and outstation requirements."
  },
  {
    "name": "Taxi in Pune",
    "description": "Hire Taxi in Pune for safe and comfortable transportation with experienced chauffeurs. Get convenient cab services for airport transfers, business travel, family trips, and sightseeing."
  },
  {
    "name": "Innova on Rent Pune",
    "description": "Book Innova on Rent Pune for spacious and premium travel with professional drivers. Ideal for family tours, airport transfers, corporate travel, and outstation journeys."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Complete Online Cab Booking Pune with simple reservations, instant confirmation, and flexible vehicle options. Enjoy hassle-free taxi booking anytime."
  },
  {
    "name": "Outstation Taxi Service Pune",
    "description": "Choose Outstation Taxi Service Pune for comfortable intercity travel with reliable chauffeurs and well-maintained vehicles. Perfect for personal, family, and corporate journeys."
  },
  {
    "name": "One Way Cab Pune",
    "description": "Book One Way Cab Pune for affordable single-trip travel with no return charges. Enjoy convenient pickup, transparent fares, and comfortable AC vehicles."
  },
  {
    "name": "Pune to Belgaum Cab",
    "description": "Reserve Pune to Belgaum Cab for safe and comfortable reverse route travel. Get experienced drivers, premium vehicles, and flexible one way or round trip options."
  },
  {
    "name": "Pune to Belgaum Cab Service",
    "description": "Choose Pune to Belgaum Cab Service for reliable transportation with professional chauffeurs and clean vehicles. Enjoy comfortable travel for business trips, family journeys, and personal visits."
  },
  {
    "name": "Pune to Belgaum Taxi",
    "description": "Book Pune to Belgaum Taxi for affordable and convenient outstation travel with multiple car options. Experience safe rides with experienced drivers and quality service."
  }
],
"tableData": [
  ["Belgaum to Pune One Way Cab", "Belgaum to Pune Private Taxi"],
  ["Belgaum to Pune Cab", "Belgaum to Pune Taxi"],
  ["Belgaum to Pune Cab Service", "Belgaum to Pune Taxi Service"],
  ["Belgaum to Pune Cab Booking", "Belgaum to Pune Car Rental"],
  ["Belgaum to Pune Outstation Cab", "Belgaum to Pune Airport Cab"],
  ["Belgaum to Pune Innova Crysta Cab", "Belgaum to Pune Ertiga Cab"],
  ["Belgaum to Pune Sedan Cab", "Belgaum to Pune Round Trip Cab"],
  ["Cheap Belgaum to Pune Cab", "Best Belgaum to Pune Cab Service"],
  ["Online Belgaum to Pune Cab Booking", "Belgaum to Pune Taxi Fare"],
  ["Belgaum to Pune Car Hire", "Belgaum to Pune Cab Price"],
  ["Belgaum to Pune Taxi Booking", "Belgaum to Pune Travel by Cab"],
  ["Belgaum to Pune Airport Transfer", "Belgaum to Pune Family Cab"],
  ["Belgaum to Pune Corporate Cab", "Cab Service in Pune"],
  ["Taxi Service in Pune", "Cab Booking in Pune"],
  ["Outstation Cabs Pune", "Cheapest Cab Service in Pune"],
  ["Taxi in Pune", "Innova on Rent Pune"],
  ["Online Cab Booking Pune", "Outstation Taxi Service Pune"],
  ["One Way Cab Pune", "Pune to Belgaum Cab"],
  ["Pune to Belgaum Cab Service", "Pune to Belgaum Taxi"]
],





whychoose: [
  {
    WhyChooseheading: "Transparent Pune to Belgaum Taxi Fare",
    WhyChoosedescription: "Belgaum Taxi Service offers clear and competitive taxi pricing for Pune to Belgaum journeys with flexible cab options based on vehicle type, travel requirements, and trip preferences."
  },
  {
    WhyChooseheading: "Budget-Friendly Travel Options",
    WhyChoosedescription: "Select from economical Sedan cabs, comfortable Ertiga, spacious Innova, and premium Innova Crysta options to match your budget and group size."
  },
  {
    WhyChooseheading: "Easy Fare Calculation",
    WhyChoosedescription: "Get a simple and transparent fare estimate based on distance, vehicle category, trip type, and additional travel requirements without confusion."
  },
  {
    WhyChooseheading: "One Way & Round Trip Pricing",
    WhyChoosedescription: "Choose a convenient one-way taxi or a return journey package with suitable pricing plans for personal, family, and business travel."
  },
  {
    WhyChooseheading: "Comfortable Long Distance Journey",
    WhyChoosedescription: "Travel from Pune to Belgaum with experienced chauffeurs, well-maintained vehicles, and a smooth ride experience throughout the route."
  },
  {
    WhyChooseheading: "Multiple Vehicle Categories Available",
    WhyChoosedescription: "Whether travelling alone, with family, or in a group, choose the right vehicle according to passenger count and luggage needs."
  },
  {
    WhyChooseheading: "No Hidden Travel Charges",
    WhyChoosedescription: "Receive upfront pricing details with complete information about applicable charges for a hassle-free taxi booking experience."
  },
  {
    WhyChooseheading: "Quick Taxi Booking Assistance",
    WhyChoosedescription: "Get instant support for Pune to Belgaum taxi enquiries, fare details, vehicle selection, and booking confirmation anytime."
  }
]

};

const faqData = [
  {
    question: "How much is the Pune to Belgaum taxi fare?",
    answer: "The Pune to Belgaum taxi fare depends on the selected vehicle, trip type, distance, and travel requirements. Contact us for an accurate quotation."
  },
  {
    question: "Does the taxi fare vary for one-way and round trips?",
    answer: "Yes, one-way and round-trip fares are calculated differently based on travel duration, vehicle category, and trip plan."
  },
  {
    question: "Which cars are available for Pune to Belgaum taxi service?",
    answer: "You can choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and other comfortable vehicles."
  },
  {
    question: "Are toll and parking charges included in the Pune to Belgaum taxi fare?",
    answer: "Toll charges, parking fees, and other applicable charges may vary depending on the selected package and are informed during booking."
  },
  {
    question: "Can I get a fixed fare for Pune to Belgaum travel?",
    answer: "Yes, you can request a fixed quotation by sharing your pickup location, travel date, passenger details, and preferred vehicle."
  },
  {
    question: "Is Pune to Belgaum taxi available for corporate travel?",
    answer: "Yes, our taxi services are suitable for business meetings, employee travel, client visits, and official journeys."
  },
  {
    question: "Can I book a Pune to Belgaum cab for family travel?",
    answer: "Yes, comfortable vehicles are available for families with spacious seating and luggage-friendly options."
  },
  {
    question: "Do you provide pickup from Pune Airport to Belgaum?",
    answer: "Yes, airport pickup and drop taxi services are available from Pune Airport to Belgaum and nearby destinations."
  },
  {
    question: "Is Pune to Belgaum taxi booking available anytime?",
    answer: "Yes, cab booking assistance is available 24/7 for planned and urgent travel requirements."
  },
  {
    question: "How can I check Pune to Belgaum Taxi Fare?",
    answer: "Share your pickup location, destination, travel date, passenger count, and preferred car type to receive the latest fare details."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kiran Joshi",
    feedback: "The Pune to Belgaum taxi quotation was clear and reasonable. The vehicle quality was excellent, and the driver made the long journey comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ananya Kulkarni",
    feedback: "I appreciated the transparent pricing and smooth booking process. The cab arrived on time, and the complete travel experience was convenient.",
    rating: 5
  }
];










    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Belgaum Taxi Fare",
  "image": "https://www.belgaumtaxiservice.com/assets/images/pune-to-belgaum-taxi-fare.webp",
  "description":
    "Book Pune to Belgaum Taxi with Belgaum Taxi Service for safe, comfortable, and affordable outstation cab services. We provide one-way and round-trip taxis from Pune to Belgaum with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business trips, airport transfers, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/pune-to-belgaum-taxi-fare"
  }
};



    return (
        <div>


<Helmet>
  <title>Pune to Belgaum Taxi Fare | One Way Cab Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Pune to Belgaum Taxi with Belgaum Taxi Service for reliable one-way and round-trip cab services. Get affordable private taxis from Pune to Belgaum with Sedan, Ertiga, SUV, Innova, and Innova Crysta options available 24x7 for comfortable outstation travel."
  />

  <meta
    name="keywords"
    content="belgaum to pune one way cab, belgaum to pune private taxi, Belgaum to Pune Cab, Belgaum to Pune Taxi, Belgaum to Pune Cab Service, Belgaum to Pune Taxi Service, Belgaum to Pune One Way Cab, Belgaum to Pune Cab Booking, Pune to Belgaum Taxi Fare, Pune to Belgaum Outstation Taxi, Pune to Belgaum Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobelgaumtaxifare;